import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, Typography } from "antd";
import { useParams } from "react-router-dom";

const { Title } = Typography;

const NoticeDetails = () => {
  const { id } = useParams();
  const [notice, setNotice] = useState({});

  useEffect(() => {
    axios.get(`https://rhrmapi.up2dateinc.com/api/notices/${id}`)
      .then(res => setNotice(res.data));
  }, [id]);

  return (
    <Card>
      <Title level={3}>Notice Details</Title>

      <p><b>Notice Date:</b> {notice.date}</p>
      <p><b>Notice By:</b> {notice.by}</p>
      <p><b>Notice:</b> {notice.type}</p>
      <p><b>Description:</b> {notice.description}</p>
    </Card>
  );
};

export default NoticeDetails;